import styled from 'styled-components';
import CheckboxOptions from './CheckboxOptions';

const DivCheckbox = styled.div`
  display: flex;
  flex-direction: column;
`;

DivCheckbox.Options = CheckboxOptions;

export default DivCheckbox;
